/* eslint-disable */
import React, { useState } from 'react';
import classNames from 'classnames';
import VideoOverlay from './VideoOverlay';
import { setImgWidth } from '../../utils/frontify';
import { Contentful, FrontifyImageContent } from '../../contentful';
import useStyles from './VideoPlayer.styles';

export interface VideoContent extends Contentful {
  fields: {
    title?: string;
    thumbnail?: FrontifyImageContent[];
    link?: string;
  };
}

export interface VideoPlayerProps {
  content: VideoContent;
  containerStyle?: string;
  smallIcon?: boolean;
}

/**
 * @deprecated V2 component
 */
export function VideoPlayer({
  content: {
    fields: { thumbnail, link },
  },
  containerStyle,
  smallIcon,
}: VideoPlayerProps) {
  const [displayVideoOverlay, setDisplayVideoOverlay] =
    useState<boolean>(false);

  const { classes } = useStyles();
  return (
    <div
      style={{
        background: `linear-gradient(rgba(211,211,211,.5), rgba(211,211,211,.5)), url(${setImgWidth(
          thumbnail?.[0].preview_url,
          1440
        )})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      className={classNames([classes.defaultVideoContainer, containerStyle])}
    >
      <div
        onClick={() => {
          setDisplayVideoOverlay(true);
        }}
      >
        <img
          src={'/cmsAssets/assets/img/video/PlayOutline.png'}
          className={smallIcon ? classes.smallIcon : classes.icon}
          alt='video player play outline'
        />
      </div>
      {displayVideoOverlay && (
        <VideoOverlay
          src={link || ''}
          onClose={() => {
            setDisplayVideoOverlay(false);
          }}
        />
      )}
    </div>
  );
}
